// material-ui
import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';

// import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';

// types
// interface Props {
//   title: string;
//   open: boolean;
//   NumeroDoc:string;
//   textoConfirmacion:any;
//   fn:any;
//   handleClose: (status: boolean) => void;
// }

// ==============================|| CUSTOMER - DELETE ||============================== //
const MySwal = Swal.mixin({});
export  function swN(ControTop: string, titulo: string, iconop: any, texto: string, callback: any) {

  MySwal.fire({
    target: document.getElementById(ControTop && ControTop !== '' ? ControTop : 'FormDatosChofer'),
    icon: iconop ? iconop : 'success', // success
    title: titulo ? titulo : 'Confirmación',
    text: texto ? texto : '',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Aceptar'
    // footer: '<a href="#">Why do I have this issue?</a>'
  }).then(() => {
    //  callback ? callback();
    if (callback) {
      // Código adicional si es necesario
      callback(); // Se ejecutará solo si la condición es verdadera
    }
  });
}
export function swNClose(){
  // swal.close();
  MySwal.close();
}
